<template>
  <div id="app" class="container-fluid">
    <div class="row flex-nowrap">
      <!-- <router-link to ="/customers/productslist">ProductList</router-link> -->
      <navbar/>
        <div class="col py-3">  
          <router-view class="debug1"/>
        </div>
    </div>
  </div>
 
</template>

<script>

import Navbar from './views/Navbar.vue'
export default {
  name : 'App',
  components : {
    Navbar
  }
}
</script>

<style>

</style>
<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */
/* 
#nav {
  padding: 30px;
} */
/* 
#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
@import './assets/style.css';
.debug1{
  border: 1px solid black;
}
</style>

